import { Tag } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export const DashboardNoticeClosedTag = ({ className, style }: Props) => {
  const { t } = useTranslation();

  return (
    <Tag color="green" className={className} style={{ textAlign: "center", ...style }}>
      {t("dashboard.notices.attrs.closed")}
    </Tag>
  );
};
